import React, { useEffect, useState } from 'react';
import { StoryblokComponent } from 'storyblok-js-client';
import { SbEditableContent } from 'storyblok-react';
import { ClientLocation, StoryblokService } from '../../services';
import { blokToComponent } from '../helpers';
import { Props } from '../types';

interface EmergencyBanner extends SbEditableContent {
  active: boolean;
  debug_as: string;
  localised_banners: LocalisedEmergencyBanner[];
  slotted_content: StoryblokComponent<''>[];
}

interface LocalisedEmergencyBanner {
  active: boolean;
  country_codes: string[];
  slotted_content: StoryblokComponent<''>[];
}

export const RocheEmergencyBanner = ({ blok, getComponent, storyId }: Props): JSX.Element => {
  const {
    active: defaultActive,
    debug_as: debugAs,
    localised_banners: localisedBanners,
    slotted_content: defaultContent,
  } = blok as EmergencyBanner;

  const [clientCountry, setCountry] = useState<string>(undefined);

  useEffect(() => {
    const isDraft = StoryblokService.getConfig().options?.headers?.Version?.toLocaleLowerCase() === 'draft';

    if (isDraft && debugAs) {
      setCountry(debugAs.toUpperCase());
      return;
    }

    ClientLocation.get()
      .then((response) => setCountry(response.country?.toUpperCase() || undefined));
  }, []);

  if (!clientCountry) {
    return null;
  }

  const localisedBanner = (localisedBanners || [])
    .filter((banner) => banner.country_codes?.includes(clientCountry));

  const { active, content } = localisedBanner.length <= 0
    ? { active: defaultActive, content: defaultContent }
    : { active: localisedBanner[0].active, content: localisedBanner[0].slotted_content };

  if (!active) {
    return null;
  }

  return (
    <roche-emergency-banner>
      {content
        .map((component) => blokToComponent(
          {
            blok: component,
            getComponent,
            storyId,
            slot: 'content',
          },
          'emergency-banner-content',
        ))}
    </roche-emergency-banner>
  );
};
